import { SimpleMutationOptions, useBaseMutation } from "../baseMutation";
import { RenameFolderFileByIdRequest, RenameFolderFileByIdResponse } from "@maven-rest/docs/FolderFile.dto";
import { FolderFileUrl } from "@maven-rest/docs/FolderFile.url";

export function useRenameFolderFileMutation(
  pathVariable: Pick<RenameFolderFileByIdRequest, "fileId">,
  options?: SimpleMutationOptions<RenameFolderFileByIdResponse, RenameFolderFileByIdRequest>
) {
  return useBaseMutation({
    fnOption: {
      url: FolderFileUrl.renameFolderFileById(pathVariable.fileId),
    },
    ...options,
  });
}
